import React from "react";
import {
  PartnerCatalog,
  PartnerCatalogBlock,
  PartnerCatalogCategory,
  PartnerCatalogUpsell,
} from "../data/catalog";
import { CategoryBlockLayout } from "./block_category_layout";
import { UpsellBlockLayout } from "./block_upsell_layout";

interface CatalogBlockProps {
  partnerCatalog: PartnerCatalog;
  block: PartnerCatalogBlock;
  partnerName?: string;
  locationAdress?: string;
}

const CatalogBlock = (props: CatalogBlockProps) => {
  const { partnerCatalog, block } = props;
  const { itemType, item } = block;

  if (!item) {
    return null;
  }

  if (itemType === "PartnerCatalogCategory") {
    return (
      <CategoryBlockLayout
        partnerCatalog={partnerCatalog}
        catalogCategory={item as PartnerCatalogCategory}
      />
    );
  }

  if (itemType === "PartnerCatalogUpsell") {
    const {
      layout,
      image,
      title,
      description: subTitle,
      longDescription,
      learnMoreURL,
      ctaLabel,
      textAlign,
      versionedImage,
    } = item as PartnerCatalogUpsell;

    return (
      <UpsellBlockLayout
        image={image}
        versionedImage={versionedImage}
        title={title}
        description={subTitle}
        learnMoreURL={learnMoreURL}
        layout={layout}
        ctaLabel={ctaLabel}
        longDescription={longDescription}
        textAlign={textAlign}
      />
    );
  }

  return null;
};

export { CatalogBlock };
